const $groups: JQuery<HTMLElement> = $('.js-filter-group');
const $filters: any = $('.js-filter-group-filters');
const $branchModal: any = $('#brancheModal');
const $hoursModal: any = $('#hoursModal');

const ALL_CHECK: string = 'js-filter-group-all';
const CHECK_ELEMENTS: string = 'input[type="checkbox"], input[type="radio"]';
const GROUP_CLASS: string = 'js-filter-group';

const filterGroup = {
  initialize(): void {
    $groups.on('change', 'input', (e: any) => {
      const $checkbox: any = $(e.currentTarget);
      const $group = this.getGroup($checkbox);
      const target: any = e.currentTarget;
      const isAllChecked = target.className.indexOf(ALL_CHECK) >= 0;
      this.checkGroup($group, isAllChecked && $checkbox.prop('checked'));
    });

    $hoursModal.add($branchModal).on('change', 'input', () => {
      this.syncFiltersWithDesktop();
    });
  },

  /**
   * Get the group around the given element
   * @param {object} $el
   * @return {object}
   */
  getGroup($el: any): any {
    return $el.parents(`.${GROUP_CLASS}`);
  },

  /**
   * Check the group for toggling 'all' checkbox etc.
   * @param {object} $group
   * @param {boolean} isAllChecked
   * @return {void}
   */
  checkGroup($group: any, isAllChecked: boolean = false): void {
    // If 'all' is checked we uncheck all other checkboxes
    if (isAllChecked) {
      $group
        .find(CHECK_ELEMENTS)
        .filter(`:not(.${ALL_CHECK})`)
        .prop('checked', false);

    // If any other checkboxes are checked we uncheck the 'all' checkbox
    } else {
      $group.find(`.${ALL_CHECK}`).prop('checked', false);
    }
  },

  syncFiltersWithDesktop() {
    $hoursModal.add($branchModal).toArray().forEach((modal: any) => {
      const $modal = $(modal);
      const $input = $modal.find('input[type="checkbox"], input[type="radio"]');
      let nonDefaultSelected = false;

      $input.toArray().forEach((input: any) => {
        const id = input.id;
        const checked = input.checked;
        const desktopId = id.replace('link_', '');
        const $desktopInput = $(`[id="${desktopId}"]`);
        const desktopInput: any = $desktopInput[0];

        desktopInput.checked = checked;
        $desktopInput.trigger('change');

        if (checked && input.className.indexOf('js-filter-group-all') < 0) {
          nonDefaultSelected = true;
        }
      });

      const $toggleButton = $(`[data-target="#${$modal.attr('id')}"]`);
      $toggleButton.toggleClass('is-filled', nonDefaultSelected);
    });
  },
};

export default filterGroup;
